import React from 'react';
import sponsoredCarouselSubtitleProps from './props';
import style from './style.module.scss';
import classNames from '../../../utils/classNames';

function SponsoredCarouselSubtitle(props: sponsoredCarouselSubtitleProps) {
  return (
    <span className={classNames('sponsored-carousel-subtitle', style, props.classNames)}
      { ...(props['data-e2e'] && { 'data-e2e': props['data-e2e'] }) }
    >
      {props.text}
    </span>
  );
}

export default React.memo(SponsoredCarouselSubtitle);